import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Typography } from '@material-ui/core';
import { Grid } from '@mui/material';
import classNames from 'classnames';
import { SGSForm, SGSFormLayout } from 'components';
import SGSSelectCtrl from 'components/SGSSelectCtrl';
import { useArretTravailFormContext } from 'features/arretTravail/contexts/ArretTravailFormProvider';
import useValidationEffects from 'features/arretTravail/hooks/useValidationEffects';
import { optionTypeAttestation, TypeAttestation } from 'features/arretTravail/models/typeAttestation/index';
import { motifArretDeclaration, optionReasonForWorkStop, ReasonForWorkStop } from 'features/arretTravail/models/workStopReason';
import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import styles from '../../../css/ArretTravail.module.scss';

type Props = {
    store: ReasonForStopSchema;
    onSubmit: (data: ReasonForStopSchema) => void;
    actions?: JSX.Element;
};

type ReasonForStopSchema = {
    typeAttestationCod: string;
    reasonForWorkStopCod: string;
};

const FormDeclarationReasons: React.FC<Props> = ({ onSubmit, store, actions }) => {
    const { t } = useTranslation();
    const { activeStep, setStepFailed } = useArretTravailFormContext();
    const requiredMessage = t('yup.validators.required');

    const validationSchema: Yup.SchemaOf<ReasonForStopSchema> = Yup.object().shape({
        typeAttestationCod: Yup.string().required(requiredMessage),
        reasonForWorkStopCod: Yup.string().required(requiredMessage),
    });
    const methods = useForm<ReasonForStopSchema>({
        resolver: yupResolver(validationSchema),
        defaultValues: store,
    });

    const {
        handleSubmit,
        watch,
        setValue,
        getValues,
        formState: { errors },
        control,
    } = methods;

    useValidationEffects({ errors, activeStep, setStepFailed, control });

    const watchTypeArret = watch('typeAttestationCod');

    useEffect(() => {
        if (watchTypeArret === TypeAttestation.Over6Months) {
            setValue('reasonForWorkStopCod', ReasonForWorkStop.Maladie);
        }
    }, [watchTypeArret, setValue, getValues]);

    const optionMotifArretFiltered = optionReasonForWorkStop.filter((option) => motifArretDeclaration.includes(option.value as ReasonForWorkStop));
    const options = watchTypeArret === TypeAttestation.Initial ? optionMotifArretFiltered : optionMotifArretFiltered.filter((option) => option.value === ReasonForWorkStop.Maladie);

    return (
        <FormProvider {...methods}>
            <SGSFormLayout onSubmit={handleSubmit(onSubmit)} actions={actions}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} md={6}>
                        <Box className={classNames(styles.title, 'mb-4')}>{t('workStop.tab.motif.title')} :</Box>
                        <FormRow label={t('workStop.tab.motif.optionTypeAttestationLabel')}>
                            <SGSSelectCtrl name="typeAttestationCod" options={optionTypeAttestation} variant="outlined" />
                        </FormRow>
                        <FormRow label="Sélectionnez le motif de l'arrêt">
                            <SGSSelectCtrl name="reasonForWorkStopCod" options={options} variant="outlined" />
                        </FormRow>
                    </Grid>
                </Grid>
            </SGSFormLayout>
        </FormProvider>
    );
};

type FormRowProps = {
    label: string;
    children: React.ReactNode;
};

const FormRow: React.FC<FormRowProps> = ({ label, children }) => (
    <SGSForm.Row>
        <SGSForm.Col md={5}>
            <Typography className={classNames(styles.fieldlabel, 'mt-3')} align="right">
                {label}
            </Typography>
        </SGSForm.Col>
        <SGSForm.Col md={6}>{children}</SGSForm.Col>
    </SGSForm.Row>
);

export default FormDeclarationReasons;
